export const APPOINTMENT_TRANSITIONS = ['appointment_scheduled'] as const;

export type AppointmentTransitionCode = (typeof APPOINTMENT_TRANSITIONS)[number];

export function isAppointmentTransition(
  code: string,
): code is AppointmentTransitionCode {
  return (APPOINTMENT_TRANSITIONS as readonly string[]).includes(code);
}
